import React from 'react';
import PropTypes from "prop-types";
import * as jotoui from "../../joto-ui-api";
import * as jotoTypes from "../../api/joto-types";
import * as joto from "../../api/joto";
import Joto from "../../api/joto";
import {connect} from "react-redux";
import Picky from 'react-picky'; // git-repository: https://github.com/Aidurber/react-picky
import { ProjectCard } from '../project-card/ProjectCard';
import {profitOptions, ProjectProperty, projectStateOptions} from '../JotoUIUtils'; 
import * as log from 'loglevel';
import produce from "immer";
import * as env from "../../env";

const logger = log.getLogger('SearchProjects.tsx');
logger.setLevel(env.logLevel);


interface SearchProjectsPageState {
    globalProjectList: jotoTypes.Projects;
}

interface SearchProjectsPageProps extends SearchProjectsPageState {
    joto: Joto,
    jotoui: jotoui.JotoUIApi;
}

interface LocalState {
    filterValuesProfit: ProjectProperty[];
    filterValuesState: ProjectProperty[]; 
    filterValuesCity: LocationOption[];
    // locationOptions : LocationOption[];
}
 

interface LocationOption {
    label: string,
    value: string
};

function zipAndCityToString(zip_code : string | null, city: string | null) {
    if(!zip_code && !city)
        return '';

    const zip_string  = zip_code ? zip_code : '';
    const city_string = city ? city : '';
    const label = zip_string + '-' + city_string;
    return label;
}

function locationOptionsFromProjectArray(projects : jotoTypes.Project[]) : LocationOption[] {
    let locationOptionLabels : string[] = [];
    for(const project of projects) {
        const label = zipAndCityToString(project.zip_code, project.city);
        if(label.length === 0)
            continue;
        locationOptionLabels.push(label);
    }
    const locationOptionUniqueLabels = Array.from(new Set(locationOptionLabels)).sort();
    const locationOptions = locationOptionUniqueLabels.map(label => ({label, value: label}));
    return locationOptions;
}

class SearchProjects_ extends React.Component<SearchProjectsPageProps, LocalState> {

    constructor(props : SearchProjectsPageProps) {
        super(props);
        const projects : jotoTypes.Project[] = joto.projectArrayFromStoreAndPathArray(this.props.globalProjectList.store, this.props.globalProjectList.projectPathList);

        this.state = {
            filterValuesProfit: profitOptions,
            filterValuesState: projectStateOptions,
            filterValuesCity: locationOptionsFromProjectArray(projects),
        };

        logger.debug(`Initial State: ${JSON.stringify(this.state)}`);
        this.handleChangeProfit = this.handleChangeProfit.bind(this);
        this.handleChangeCity = this.handleChangeCity.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this); 
    }



    handleChangeProfit(object_list : ProjectProperty[]) {
        const newState = produce(this.state, draft => {
            draft.filterValuesProfit = [...object_list];
        });
        this.setState(newState);
    }

    handleChangeCity(object_list : LocationOption[]) {
        const newState = produce(this.state, draft => {
            draft.filterValuesCity = [...object_list];
        });
        this.setState(newState);
    }

    handleChangeState(object_list: ProjectProperty[]){
        console.debug(`object list: ${JSON.stringify(object_list)}`)
        const newState = produce(this.state, draft => {
            draft.filterValuesState = [...object_list]
        })
        this.setState(newState); 
    }


    convertProjectToReactCard = (project : jotoTypes.Project, i : number) => {
        if(typeof project !== 'undefined') {
            return <div key={`project${i}`} className="col-12 col-xl-3 col-lg-4 col-md-6"><ProjectCard project={project} jotoui={this.props.jotoui}/></div>
        } else {
            return null;
        }
    };



    render(){
        const projects : jotoTypes.Project[] = joto.projectArrayFromStoreAndPathArray(this.props.globalProjectList.store, this.props.globalProjectList.projectPathList);
        // filter by project category

        let projectsSelected : jotoTypes.Project[] = [];
        let globalProjects : jotoTypes.Project[] = [];

        const selectedZips   : string[] = [];

        // get all selected cities and zip-codes
        for(const locationOption of this.state.filterValuesCity) {
            const {label} = locationOption;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [zip, city, _] = label.split('-');
            if(zip) selectedZips.push(zip);
            if(city) selectedZips.push(city);
        }

        for (let i = 0; i < projects.length; i++){
            let project = projects[i]; 
            // filter project for-profit category
            if (this.state.filterValuesProfit.map(({label, value}) => value).includes(project.forProfit)){
                // filter project state 
                if (this.state.filterValuesState.map(({label, value}) => value).includes(project.state))
                    // filter zip-code
                    if (project.zip_code){
                        if (selectedZips.includes(project.zip_code)){
                            projectsSelected.push(project)
                        }
                    } else {
                        globalProjects.push(project)
                    }   
            }
        }

        const locationOptions = locationOptionsFromProjectArray(projects); 
        
        // sort by popularity:
        projectsSelected = projectsSelected.sort((a, b) => b.likeCount-a.likeCount);
        globalProjects   = globalProjects.sort((a, b) => b.likeCount-a.likeCount);

        const projectsSelectedList = <div className="row">{projectsSelected.map(this.convertProjectToReactCard).filter(Boolean)}</div>;
        const globalProjectsList   = globalProjects.length === 0 ? null : <div className="row">{globalProjects.map(this.convertProjectToReactCard).filter(Boolean)}</div>;

        logger.debug(`Selected locations: ${JSON.stringify(this.state.filterValuesCity)}`);
        logger.debug(`Length of project list: ${projectsSelected.length}`);

        return (
        <div >
            <h1> Finde dein Projekt</h1>
            <Picky 
            className="picky-custom"
            id="picky-city"
            options={locationOptions}
            value={this.state.filterValuesCity}
            labelKey="label"
            valueKey="value"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            numberDisplayed={0}
            onChange={this.handleChangeCity}
            dropdownHeight={600}
            placeholder="Ortseinschränkung"
            manySelectedPlaceholder="Ortseinschränkung"
            allSelectedPlaceholder="Ortseinschränkung"
            /> 
            <Picky 
            className="picky-custom"
            id="picky-city"
            options={projectStateOptions}
            value={this.state.filterValuesState}
            labelKey="label"
            valueKey="value"
            multiple={true}
            includeSelectAll={false}
            includeFilter={false}
            numberDisplayed={0}
            onChange={this.handleChangeState}
            dropdownHeight={600}
            placeholder="Projektstatus"
            manySelectedPlaceholder="Projektstatus"
            allSelectedPlaceholder="Projektstatus"
            /> 
            <Picky 
            className="picky-custom"
            id="picky"
            options={profitOptions}
            value={this.state.filterValuesProfit}
            labelKey="label"
            valueKey="value"
            multiple={true}
            includeSelectAll={false}
            includeFilter={false}
            numberDisplayed={0}
            manySelectedPlaceholder="Profitorientiert"
            allSelectedPlaceholder="Profitorientiert"
            onChange={this.handleChangeProfit}
            dropdownHeight={600}
            placeholder="Projektorientiert"/>
           <hr/>
            {projectsSelectedList}
            {
                !globalProjectsList ? null : (<><h1>Ortsunabhängige Projekte</h1><hr/>{globalProjectsList}</>)
            }
        </div>
        ); 
    }
}

// @ts-ignore
SearchProjects_.propTypes = {
    jotoui: PropTypes.object.isRequired,
};

// function to map state to properties for redux

const SearchProjects_mapStateToProps = (state : jotoui.JotoUIState) : SearchProjectsPageState => ({
    globalProjectList : state.globalProjectList,
});
// filter: state.ui.searchProjects.filter

// connect states, properties and React-Component for redux 
const SearchProjects = connect(SearchProjects_mapStateToProps)(SearchProjects_);

export {SearchProjects}; 
// 42 84 91
